"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkmark = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkboxTheme = require("../checkboxTheme");
var _CheckmarkStyled = require("../styled/CheckmarkStyled");
const Checkmark = props => {
  return /*#__PURE__*/_react.default.createElement(_CheckmarkStyled.CheckmarkStyled, {
    size: _checkboxTheme.checkmarkTheme.size[props.size](props.themeMode)
  }, getSvg(props));
};
exports.Checkmark = Checkmark;
const ursaIndeterminate = /*#__PURE__*/_react.default.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M6 10h8",
  stroke: "currentColor",
  strokeWidth: "1.75",
  strokeLinecap: "round"
}));
const ursaCheck = /*#__PURE__*/_react.default.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "m6 9.875 2.75 2.75L14 7.375",
  stroke: "currentColor",
  strokeWidth: "1.75",
  strokeLinecap: "round"
}));
const lodestarIndeterminate = /*#__PURE__*/_react.default.createElement("svg", {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("rect", {
  x: "4",
  y: "8.5",
  width: "12",
  height: "3",
  rx: "1.5",
  fill: "currentColor"
}));
const lodestarCheck = /*#__PURE__*/_react.default.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.7 4.41a1.49 1.49 0 0 1 2.09-.47c.66.44.86 1.32.45 2l-5.88 9.79c-.41.68-1.36.77-1.9.19l-4.52-4.94c-.54-.59-.52-1.5.04-2.06.6-.6 1.59-.58 2.16.04l2.91 3.18 4.65-7.73Z",
  fill: "currentColor"
}));

// using the following icons instead of anything from @smartsheet/ursa-icons because they have
// different sizing/pattern for this one-off situation

const ursaStar = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "M10 0c.338 0 .646.195.79.5l2.657 5.604 5.793.766a.875.875 0 0 1 .528 1.46l-4.151 4.496 1.145 6.139a.875.875 0 0 1-1.253.942L10 17.137l-5.509 2.77a.875.875 0 0 1-1.253-.942l1.145-6.139-4.15-4.495A.875.875 0 0 1 .76 6.87l5.793-.766L9.21.5A.875.875 0 0 1 10 0Z"
}));
const ursaStarEmpty = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "m10.125 16.157-5.902 2.968 1.226-6.57L1 7.737l6.265-.828 2.86-6.034 2.86 6.034 6.265.828-4.449 4.818 1.226 6.57-5.902-2.968Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 0c.338 0 .646.195.79.5l2.657 5.604 5.793.766a.875.875 0 0 1 .528 1.46l-4.151 4.496 1.145 6.139a.875.875 0 0 1-1.253.942L10 17.137l-5.509 2.77a.875.875 0 0 1-1.253-.942l1.145-6.139-4.15-4.495A.875.875 0 0 1 .76 6.87l5.793-.766L9.21.5A.875.875 0 0 1 10 0Zm0 2.918L7.93 7.284a.875.875 0 0 1-.676.493l-4.591.606 3.304 3.578a.875.875 0 0 1 .217.755l-.902 4.834 4.325-2.175a.875.875 0 0 1 .786 0l4.325 2.175-.902-4.835a.875.875 0 0 1 .217-.754l3.304-3.578-4.591-.606a.875.875 0 0 1-.677-.493L10 2.918Z",
  clipRule: "evenodd"
}));
const ursaFlag = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "M3.482 0c.483 0 .875.392.875.875v2.178h12.16a.875.875 0 0 1 .715 1.38l-2.901 4.1 2.901 4.1a.875.875 0 0 1-.714 1.38H4.358v5.112a.875.875 0 0 1-1.75 0V.875c0-.483.39-.875.874-.875Z"
}));
const ursaFlagEmpty = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "M16.036 3.928H3v9.21h13.036l-3.26-4.605 3.26-4.605Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.482 0c.483 0 .875.392.875.875v2.178h12.16a.875.875 0 0 1 .715 1.38l-2.901 4.1 2.901 4.1a.875.875 0 0 1-.714 1.38H4.358v5.112a.875.875 0 0 1-1.75 0V.875c0-.483.39-.875.874-.875Zm.875 12.263h10.47l-2.282-3.225a.875.875 0 0 1 0-1.01l2.282-3.225H4.357v7.46Z",
  clipRule: "evenodd"
}));
const getSvg = props => {
  if (props.appearance === "check") {
    switch (props.themeMode) {
      case "ursa-light":
      case "ursa-dark":
        // Note that these svgs apply their color via stroke, not fill.
        return props.checkedState === "indeterminate" ? ursaIndeterminate : ursaCheck;
      case "oldestar":
      case "lodestar-light":
      default:
        // Note that these svgs apply their color via fill, not stroke.
        return props.checkedState === "indeterminate" ? lodestarIndeterminate : lodestarCheck;
    }
  } else if (props.appearance === "flag") {
    return props.checkedState === "checked" ? ursaFlag : ursaFlagEmpty;
  } else if (props.appearance === "star") {
    return props.checkedState === "checked" ? ursaStar : ursaStarEmpty;
  }
};
//# sourceMappingURL=Checkmark.js.map